import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Card from "../Cards/Card";
import { getAllCustomers, getAllPurchases } from "../../api";
import "./Dashboard.css";

const Dashboard = () => {
  const navigate = useNavigate();
  const [customerCount, setCustomerCount] = useState(0);
  const [recentPurchases, setRecentPurchases] = useState([]);

  useEffect(() => {
    fetchCustomerCount();
    fetchRecentPurchases();
  }, []);

const fetchCustomerCount = async () => {
  try {
    const response = await getAllCustomers();

    const uniqueCustomers = new Set(
      response.data
        .filter((customer) => parseFloat(customer.invoice_total) > 0)
        .map((customer) => customer.customer_id)
    );

    setCustomerCount(uniqueCustomers.size);
  } catch (error) {
    console.error("Error fetching customers:", error);
  }
};


  const fetchRecentPurchases = async () => {
    try {
      const response = await getAllPurchases();
      const validPurchases = response.data.filter(
        (purchase) => parseFloat(purchase.invoice_total) > 0
      );
      const latestPurchases = validPurchases.slice(-3).reverse();
      setRecentPurchases(latestPurchases);
    } catch (error) {
      console.error("Error fetching purchases:", error);
    }
  };

  const handleViewPurchases = () => {
    navigate("/admin/dashboard/manage-purchase");
  };

  const handleViewCustomers = () => {
    navigate("/admin/dashboard/manage-customer");
  };

  return (
    <div className="dashboard-content">
      <div className="card-container">
        <Card title="Created Customers">
          <p className="statistic">{customerCount} Customers</p>
          <button className="view-button" onClick={handleViewCustomers}>
            View All
          </button>
        </Card>

        <Card title="Recent Purchases">
          <ul>
            {recentPurchases.length > 0 ? (
              recentPurchases.map((purchase) => (
                <li key={purchase.id}>
                  <strong>Invoice:</strong> {purchase.invoice_no} |{" "}
                  <strong>AED </strong>
                  {purchase.invoice_total}
                </li>
              ))
            ) : (
              <li>No purchases found</li>
            )}
          </ul>
          <button className="view-button" onClick={handleViewPurchases}>
            View All
          </button>
        </Card>
      </div>
    </div>
  );
};

export default Dashboard;
